<template>
  <div>
    <div class="group-detail">
      <div class="content-wrapper">
        <div class="main-content">
          <div class="main-content__csv-box">
            <p>Tutor csv</p>
            <FileInput v-model="selectedCsvTutor" @changedFile="errors = null" />
          </div>
          <div class="main-content__csv-box">
            <p>Student csv</p>
            <FileInput v-model="selectedCsvStudent" @changedFile="errors = null" />
          </div>
          <div class="main-content__msg-box">
            <ErrorCsv :errorMessages="errors" />
          </div>
        </div>
        <div class="button-container">
          <div
            @click="confirmUploadCsv"
            class="import-button"
            :disabled="isAssignment"
          >
            Import
          </div>
        </div>
      </div>
    </div>

    <Loading :isLoading="isAssignment" />
  </div>
</template>

<script lang="ts">
import _ from 'lodash';
// @ts-expect-error 型チェック不要部分
import FileSaver from 'file-saver'
import FileInput from '@/components/parts/inputItem/FileInput.vue';
import ErrorCsv from '@/components/parts/ErrorCsv.vue';
import { readCsv, countRecords } from '@/utils/csv'
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator'
import { AssignmentStatus } from '@/store/groups/formation/types';
import Loading from '@/components/parts/modal/Loading.vue'

@Component({
  components: {
    FileInput,
    ErrorCsv,
    Loading,
  },
})
export default class GroupAssignment extends Vue {
  @Prop({ required: true }) selectedAssignment!: AssignmentStatus

  selectedCsvTutor: File|null = null

  selectedCsvStudent: File|null = null

  errors: string|null = null

  isAssignment: boolean = false

  warnings: string[] = []

  async confirmUploadCsv() {
    if (this.isAssignment) return // インポート中は無視

    this.errors = null
    if (_.isNull(this.selectedCsvTutor) || _.isNull(this.selectedCsvStudent)) {
      this.errors = 'Please select Tutor & Student csv.'
      return
    }

    try {
      const tutorReader = await readCsv(this.selectedCsvTutor)
      const studentReader = await readCsv(this.selectedCsvStudent)
      const tutorsCount = countRecords(tutorReader)
      const studentsCount = countRecords(studentReader);

      const isOk = await this.$bvModal.msgBoxConfirm(
        `Import ${tutorsCount} tutors and ${studentsCount} students. Is it OK?`,
        {
          centered: true,
        },
      )

      if (isOk === true) {
        this.assignGroup()
      }
    } catch (error) {
      this.errors = 'selected file has error. please select file again.'
      this.selectedCsvTutor = null
      this.selectedCsvStudent = null
    }
  }

  assignGroup() {
    this.isAssignment = true
    this.$store.dispatch('assignGroupByCsv', {
      assignment: this.selectedAssignment,
      tutorCsv: this.selectedCsvTutor,
      studentCsv: this.selectedCsvStudent,
    })
      .then(() => {
        this.$bvModal.msgBoxOk('Success !')
          .then(() => this.$emit('complete'))
      })
      .catch((error) => {
        this.errors = error
      })
      .finally(() => {
        this.isAssignment = false
      })
  }

  checkError(error: string) {
    this.errors = error
  }
}

</script>

<style scoped>
h1 {
  text-align: center;
  margin-bottom:20px;
}

.sub-title {
  padding:10px;
  margin-bottom: 20px;
  background: #DDEAF6;
  display: flex;
  align-items: center;
}

.main-content {
  padding: 20px;
  border-radius: 20px;
  margin-bottom:20px;
  min-height: 500px;
}

.content-wrapper {
  background: #D8D8D8;
  padding: 20px 20px;
}

.button-container {
  display: flex;
  justify-content: center;
}

.import-button {
  margin-left:10px;
  display: block;
  text-decoration: none;
  color: #ffffff;
  min-width: 120px;
  font-size:15px;
  line-height: 15px;
  text-align: center;
  padding: 10px;
  border: 3px solid #1cc8a0;
  border-radius: 20px;
  cursor: pointer;
  transition: .2s;
  user-select:none;
  background: #1cc8a0;
}

.import-button:hover {
  background: #fff;
  color: #1cc8a0;
}

.main-content p {
  display: block;
  text-align: left;
  margin:10px 0;
  font-weight: bold;
  text-align: left;
  margin:10px 0;
  font-weight: bold;
}

.main-content__csv-box {
  margin-bottom:70px;
  padding-right: 30px;
  padding-left: 30px;
}
</style>
